import React from "react";
import "./ProductCard.scss";
import defaultImg from "../../Assets/images/defaultImg.png";
import ProductCardPrice from "./ProductCardPrice";
import { Link } from "react-router-dom";

const ProductCard = (props) => {
  const grayImageClass = props.status === false ? "class_grayImage" : "";
  return (
    <div
      className={`productCardWrapper__ ${
        props.className !== undefined ? props.className : ""
      } `}
    >
      <Link
        to={`/Group/product/${props.id}-${props?.title.replace(/\s+/g, '-')}`}
        state={{ id: props.id }}
        className="productCardImg__"
      >
        {props.offer && (
          <div className="offerPercent__">{props.offPercent}%</div>
        )}
        <img
          className={grayImageClass}
          src={
            props.src === undefined || props.src === "" ? defaultImg : props.src
          }
          alt=""
        />
      </Link>
      <div className="productCardTitlePrnt__">
        <div className="productCardTitle__">
          <span>{props.title}</span>
          {props.status ? (
            <span></span>
          ) : (
            <span>{props.inventory}</span>
          )}
        </div>
        {props.status && (
          <ProductCardPrice
            mainPrice={props.mainPrice}
            offer={props.offer}
            offerPrice={props.offerPrice}
            score={props.score}
            productInfo={props.productInfo}
            defaultWeight={props.defaultValue}
            inventory={props.inventory}
          />
        )}
      </div>
    </div>
  );
};

export default ProductCard;
